'use client';
import { useState } from 'react';

export default function AreaPrivada() {
  const [pass, setPass] = useState('');
  const [mensaje, setMensaje] = useState('');

  const verificar = async () => {
    const res = await fetch('/api/secret', {
      method: 'POST',
      body: JSON.stringify({ password: pass }),
    });
    const data = await res.json();
    if (res.ok) setMensaje(data.contenido);
    else alert("Contraseña incorrecta");
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-900 text-white p-4">
      <h1 className="text-3xl mb-6">Área Restringida</h1>
      {mensaje ? (
        <div className="p-6 bg-green-900 rounded-lg">{mensaje}</div>
      ) : (
        <div className="flex flex-col gap-4">
          <input 
            type="password" 
            placeholder="Introduce la contraseña" 
            className="p-2 rounded text-black"
            onChange={(e) => setPass(e.target.value)}
          />
          <button onClick={verificar} className="bg-blue-600 p-2 rounded">Desbloquear</button>
        </div>
      )}
      <a href="/" className="mt-10 text-sm underline">Volver al inicio</a>
    </div>
  );
}